module.exports = __webpack_public_path__ + "static/media/section_1_2_B.639d1680.png";